<template lang="pug">
	v-app#inspire
		router-view
		alert
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'App',
	computed: {
		...mapState({
			drawer: (state) => state.data.drawer
		}),
	},
	created() {
        this.$store.dispatch('data/getCurrentBranch');
		this.locales = Object.keys(this.$vuetify.lang.locales);

        const savedLocale = window.localStorage.getItem('locale');
        const locale = this.locales.includes(savedLocale) ? savedLocale : 'ru';

        this.$vuetify.lang.current = locale;
	},
	mounted: function() {
		window.scrollTo(0, 0);

		window.addEventListener('keydown', this.keydownHandler);
	},
	methods: {
		keydownHandler(e) {
			if (e.repeat) { return false; }

			if ( e.ctrlKey && e.keyCode === 192 ) {
				this.$store.commit('data/SET_DRAWER', !this.drawer);
			}
		}
	}
};
</script>
